module.exports = __webpack_public_path__ + "img/thumb_evm.34ec207d.jpg";